import * as Yup from 'yup';

export const RESOURCE_TYPES = ['Guías', 'Estudios', 'Anuarios', 'Informes', 'Nota de prensa'];

export const initValuesResource = {
    title: '',
    type: '',
    publication_date: null,
    url: '',
    description: '',
};

export const validationSchemaResource = Yup.object({
    title: Yup.string()
        .required('El título es requerido')
        .max(120, 'El título no puede exceder 120 caracteres'),
    type: Yup.string()
        .required('El tipo es requerido')
        .oneOf(RESOURCE_TYPES, 'Tipo inválido'),
    publication_date: Yup.date()
        .required('La fecha de publicación es requerida')
        .nullable(),
    url: Yup.string()
        .required('La URL es requerida'),
    description: Yup.string().nullable(),
});
